export default __webpack_public_path__ + "338e7c16f05a1c1065b84e671dba89d5.svg";